module.exports = __webpack_public_path__ + "img/zhenduanjilu.e59a54f9.svg";